import { BaseDictionaryItem } from '../../public_api';

export class SourcesDictionaryItem extends BaseDictionaryItem {
  public static readonly URL = 'url';

  public readonly url: string;

  protected constructor(sourceObject: Record<string, unknown>, id: string, name: string, description: string) {
    super(sourceObject, id, name, description);
    this.url = super._getString(SourcesDictionaryItem.URL);
  }
}
